import { Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';
import { desktopHandoffGuard } from './core/desktop-handoff/desktop-handoff.guard';

export const appRoutes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'tabs/home' },

  {
    path: 'desktop',
    loadComponent: () => import('./core/desktop-handoff/desktop-handoff.page').then(m => m.DesktopHandoffPage),
  },

  {
    path: 'login',
    canMatch: [desktopHandoffGuard],
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage),
  },
  {
    path: 'auth-redirect',
    loadComponent: () => import('./pages/login/auth-redirect.page').then(m => m.AuthRedirectPage),
  },

  {
    path: 'tabs',
    canMatch: [desktopHandoffGuard],
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/tabs/tabs.page').then(m => m.TabsPage),
    children: [
      { path: 'home', loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage) },
      {
        path: 'inbox',
        loadComponent: () => import('./pages/inbox/inbox.page').then(m => m.InboxPage),
      },
      {
        path: 'inbox/:id',
        loadComponent: () => import('./pages/inbox/inbox-detail.page').then(m => m.InboxDetailPage),
      },
      {
        path: 'files',
        loadComponent: () => import('./pages/files/files.page').then(m => m.FilesPage),
      },
      {
        path: 'files/:id',
        loadComponent: () => import('./pages/files/file-viewer.page').then(m => m.FileViewerPage),
      },
      {
        path: 'requests/check-deposits',
        loadComponent: () => import('./pages/requests/check-deposits.page').then(m => m.CheckDepositsPage),
      },
      {
        path: 'requests/print-mail',
        loadComponent: () => import('./pages/requests/print-mail.page').then(m => m.PrintMailPage),
      },
      {
        path: 'requests',
        loadComponent: () => import('./pages/placeholders/request-history.page').then(m => m.RequestHistoryPage),
      },

      // Back-compat alias
      { path: 'request-history', pathMatch: 'full', redirectTo: 'requests' },

      // Compatibility alias: some Ionic tab behaviors navigate to /tabs/<tab>
      // based on the tab id. Keep Account as an alias of Settings/Preferences.
      { path: 'account', pathMatch: 'full', redirectTo: 'settings' },

      {
        path: 'settings',
        loadComponent: () => import('./pages/settings/settings.page').then(m => m.SettingsPage),
      },
      {
        path: 'settings/phone',
        loadComponent: () => import('./pages/phone/phone.page').then(m => m.PhonePage),
      },
      {
        path: 'settings/phone/number',
        loadComponent: () => import('./pages/phone/phone-number.page').then(m => m.PhoneNumberPage),
      },
      {
        path: 'settings/phone/forwarding',
        loadComponent: () => import('./pages/phone/phone-forwarding.page').then(m => m.PhoneForwardingPage),
      },
      {
        path: 'settings/phone/review',
        loadComponent: () => import('./pages/phone/phone-review.page').then(m => m.PhoneReviewPage),
      },
      {
        path: 'settings/phone/calls',
        loadComponent: () => import('./pages/phone/phone-calls.page').then(m => m.PhoneCallsPage),
      },
      {
        path: 'settings/phone/voicemails',
        loadComponent: () => import('./pages/phone/phone-voicemails.page').then(m => m.PhoneVoicemailsPage),
      },
      {
        path: 'settings/phone/settings',
        loadComponent: () => import('./pages/phone/phone-settings.page').then(m => m.PhoneSettingsPage),
      },
      {
        path: 'settings/phone/cancel',
        loadComponent: () => import('./pages/phone/phone-cancel.page').then(m => m.PhoneCancelPage),
      },
      { path: '', pathMatch: 'full', redirectTo: 'home' },
    ],
  },

  { path: '**', redirectTo: 'tabs/inbox' },
];
